import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import AOS from 'aos';
import 'aos/dist/aos.css'; // Import AOS styles

const AdvancedHMS = () => {
  const [visibleItems, setVisibleItems] = useState([]);
  const itemRefs = useRef([]);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    countryCode: '+91',
    phone_number: '',
    subject: '',
    message: '',
  });
  const [formMessage, setFormMessage] = useState('');
  const videoRef = useRef(null);

  useEffect(() => {
    // Scroll to top on mount
    window.scrollTo(0, 0);

    // Initialize WOW.js for animations
    if (window.WOW) {
      new window.WOW().init();
    }

    // Initialize AOS
    AOS.init({
      duration: 1000,
      once: true,
      easing: 'ease-in-out',
    });

    // Google Analytics
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    gtag('js', new Date());
    gtag('config', 'G-P2TS4436R5');

    // Intersection Observer for animated items
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisibleItems((prev) => [...prev, entry.target.dataset.index]);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    itemRefs.current.forEach((item) => {
      if (item) observer.observe(item);
    });

    // Parallax effect for video
    const handleScroll = () => {
      if (videoRef.current) {
        const scrollPosition = window.scrollY;
        const videoHeight = videoRef.current.offsetHeight;
        const translateY = scrollPosition * 0.3;
        videoRef.current.style.transform = `translateY(${translateY}px)`;
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      itemRefs.current.forEach((item) => {
        if (item) observer.unobserve(item);
      });
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
    if (id === 'countryCode') {
      document.getElementById('phone_number').placeholder = `Your Phone Number (${value})`;
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Simulate form submission (replace with actual API call if needed)
    setFormMessage('✅ Message Sent Successfully!');
    setTimeout(() => setFormMessage(''), 3000);
    setFormData({
      name: '',
      email: '',
      countryCode: '+91',
      phone_number: '',
      subject: '',
      message: '',
    });
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Navbar */}
      <Navbar />

      {/* Header with Parallax Video */}
      <div className="relative h-[40vh] min-h-[300px] xs:h-[45vh] sm:h-[50vh] md:h-[60vh] lg:h-[70vh] xl:h-[80vh] 2xl:h-[85vh] overflow-hidden" data-aos="fade">
        <video
          ref={videoRef}
          className="absolute top-0 left-0 w-full h-[130%] object-cover"
          autoPlay
          loop
          muted
          playsInline
        >
          <source src="/video/HMS.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="absolute inset-0 bg-black opacity-50"></div>
<div className="relative z-10 w-full h-full flex flex-col justify-between">
          <div className="text-left py-4 px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-20">
            <h1
              className="text-xl xs:text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold text-white wow animate__zoomIn"
              data-wow-delay="0.1s"
            >
             Our Products
            </h1>
          </div>
          <div
            className="bg-white mx-auto"
            style={{
              width: "80%",
              height: "1px",
              maxWidth: "1200px",
            }}
          ></div>
          <div className="absolute inset-0 flex items-center justify-center px-4 sm:px-6">
            <h1
              className="text-lg xs:text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-extrabold text-white wow animate__zoomIn text-center"
              data-wow-delay="0.3s"
            >
              Hospital Management System
            </h1>
          </div>
        </div>
        <div className="absolute inset-0 bg-black opacity-50 flex items-center justify-center">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12 lg:py-16">
        {/* Section 1: Introduction */}
        <section className="mb-12 sm:mb-16 lg:mb-20" data-aos="fade-up">
          <div className="bg-white rounded-2xl shadow-lg p-6 sm:p-8">
            <h1 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-gray-900 mb-3 sm:mb-4">
              Advanced Hospital Management System
            </h1>
            <h2 className="text-lg sm:text-xl md:text-2xl font-semibold text-gray-800 mb-4 sm:mb-6">
              for Smarter Care & Streamlined Operations
            </h2>
            <p className="text-sm sm:text-base md:text-lg text-gray-700 mb-6 sm:mb-8 animate-fadeIn">
              SecurXpert's Advanced Hospital Management System streamlines care and operations in one secure platform - enabling faster workflows, more intelligent decisions and better patient outcomes.
            </p>
            <Link
              to="/contact-us"
              className="inline-block bg-indigo-600 text-white font-semibold py-2 px-6 sm:py-3 sm:px-8 rounded-lg hover:bg-indigo-700 transition duration-300 text-sm sm:text-base no-underline hover:scale-105"
            >
              Book a Demo
            </Link>
          </div>
        </section>

        {/* Section 2: Who It’s For */}
        <section className="mb-12 sm:mb-16 lg:mb-20" data-aos="fade-up">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 text-center mb-6 sm:mb-8 lg:mb-10">
            Who It’s For
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
            {[
              {
                icon: 'fas fa-hospital',
                title: 'Multi-specialty hospitals',
                description: 'Centralized Hospital Management System to manage complex operations across departments.',
              },
              {
                icon: 'fas fa-clinic-medical',
                title: 'Single-location clinics',
                description: 'Simple, effective hospital management software for daily tasks and patient care.',
              },
              {
                icon: 'fas fa-vial',
                title: 'Diagnostic centres & laboratories',
                description: 'Streamline testing, reporting, and patient record management with integrated solutions.',
              },
              {
                icon: 'fas fa-prescription-bottle',
                title: 'Pharmacies',
                description: 'Real-time stock control and integrated billing within the HMS software.',
              },
              {
                icon: 'fas fa-ambulance',
                title: 'Ambulance services',
                description: 'GPS tracking, scheduling, and patient handover coordination for efficient operations.',
              },
              {
                icon: 'fas fa-users',
                title: 'Community health organisations',
                description: 'Scalable solutions for patient data, outreach, and reporting needs.',
              },
            ].map((item, index) => (
              <div
                key={index}
                className={`bg-white rounded-2xl shadow-md p-4 sm:p-6 hover:shadow-xl hover:scale-105 transition-all duration-500 ${
                  visibleItems.includes(String(index + 2)) ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
                }`}
                data-index={index + 2}
                ref={(el) => (itemRefs.current[index + 2] = el)}
                data-aos="zoom-in"
                data-aos-delay={index * 100}
              >
                <i className={`${item.icon} text-indigo-600 text-2xl sm:text-3xl mb-3 sm:mb-4`}></i>
                <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2 sm:mb-3">{item.title}</h3>
                <p className="text-sm sm:text-base text-gray-700">{item.description}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Section 3: Unique Features */}
        <section className="mb-12 sm:mb-16 lg:mb-20" data-aos="fade-up">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 text-center mb-6 sm:mb-8 lg:mb-10">
            Unique Features
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
            {[
              {
                icon: 'fas fa-desktop',
                title: 'Role-Based Dashboards',
                description: 'Personalised views for doctors, nurses, labs, admin, and finance for efficient workflows.',
                placeholder: 'img/Role-Based Dashboards (1).png',
              },
              {
                icon: 'fas fa-bed',
                title: 'Smart Bed & OT Scheduling',
                description: 'AI-powered planning to optimise bed usage and streamline patient movement.',
                placeholder: 'img/Smart Bed & OT Scheduling (1).png',
              },
              {
                icon: 'fas fa-microphone',
                title: 'Hands-Free Commands',
                description: 'Voice-enabled tools for quick note-taking and safe, efficient order entry.',
                placeholder: 'img/Hands-Free Commands (1).png',
              },
              {
                icon: 'fas fa-wifi',
                title: 'Offline Functionality',
                description: 'Continue operations without internet and auto-sync data when reconnected.',
                placeholder: 'img/Offline Functionality (1).png',
              },
              {
                icon: 'fas fa-comments',
                title: 'Patient Communication Tools',
                description: 'Send reminders, share reports and engage patients via WhatsApp or SMS.',
                placeholder: 'img/Patient Communication Tools.png',
              },
              {
                icon: 'fas fa-cogs',
                title: 'Flexible Workflows',
                description: 'Customise forms, steps and approvals to match your hospital’s unique processes.',
                placeholder: 'img/Flexible Workflows.png',
              },
              {
                icon: 'fas fa-file-alt',
                title: 'Instant Compliance Reports',
                description: 'Generate NABH, NABL and statutory reports instantly in approved formats.',
                placeholder: 'img/Instant Compliance Reports.png',
              },
              {
                icon: 'fas fa-plug',
                title: 'Seamless System Integration',
                description: 'Connect with EHR, FHIR, PACS/RIS/LIS, payment gateways and government portals.',
                placeholder: 'img/Seamless System Integration.png',
              },
              {
                icon: 'fas fa-headset',
                title: '24/7 Expert Support',
                description: 'Get help, training and guidance at any time of the day from our healthcare IT specialists.',
                placeholder: 'img/247 Expert Support.png',
              },
            ].map((item, index) => (
              <div
                key={index}
                className={`bg-white rounded-2xl shadow-md p-4 sm:p-6 hover:shadow-xl hover:scale-105 transition-all duration-500 ${
                  visibleItems.includes(String(index + 8)) ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
                }`}
                data-index={index + 8}
                ref={(el) => (itemRefs.current[index + 8] = el)}
                data-aos="zoom-in"
                data-aos-delay={index * 100}
              >
                <img
                  src={item.placeholder}
                  alt={`${item.title} placeholder`}
                  className="w-full h-auto mb-3 sm:mb-4"
                  style={{ width: '404px', height: '269px' }}
                />
                <i className={`${item.icon} text-indigo-600 text-2xl sm:text-3xl mb-3 sm:mb-4`}></i>
                <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2 sm:mb-3">{item.title}</h3>
                <p className="text-sm sm:text-base text-gray-700">{item.description}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Section 4: Key Modules */}
        <section className="mb-12 sm:mb-16 lg:mb-20" data-aos="fade-up">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 text-center mb-6 sm:mb-8 lg:mb-10">
            Key Modules
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-8">
            {[
              'EHR (Electronic Health Records)',
              'OPD & IPD Management',
              'Appointments & Scheduling',
              'Billing & Insurance',
              'Labs & Pathology',
              'Radiology & Imaging',
              'Pharmacy',
              'Inventory',
              'Blood Bank',
              'Ambulance Management',
              'Birth/Death Records',
              'HR & Payroll',
              'TPA Management',
              'Reports & Analytics',
            ].map((module, index) => (
              <div
                key={index}
                className={`bg-white rounded-2xl shadow-md p-4 sm:p-6 text-center hover:shadow-xl hover:scale-105 transition-all duration-500 ${
                  visibleItems.includes(String(index + 17)) ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
                }`}
                data-index={index + 17}
                ref={(el) => (itemRefs.current[index + 17] = el)}
                data-aos="zoom-in"
                data-aos-delay={index * 100}
              >
                <h3 className="text-base sm:text-lg font-semibold text-gray-900">{module}</h3>
              </div>
            ))}
          </div>
        </section>

        {/* Section 5: Why Choose SecurXpert HMS */}
        <section
          className="mb-12 sm:mb-16 lg:mb-20 bg-fixed bg-cover bg-center"
          style={{ backgroundImage: "url('/img/healthcare-bg.png')" }}
          data-aos="fade-up"
        >
          <div className="bg-white bg-opacity-90 rounded-2xl p-6 sm:p-8">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 text-center mb-6 sm:mb-8 lg:mb-10">
              Why Choose SecurXpert HMS?
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 lg:gap-8">
              {[
                {
                  icon: 'fas fa-hospital-alt',
                  title: 'Built for Healthcare',
                  description: 'Created to match the real needs and workflows of modern hospitals and clinics.',
                },
                {
                  icon: 'fas fa-bolt',
                  title: 'Faster Workflows',
                  description: 'Streamlined processes across all hospital departments for better efficiency.',
                },
                {
                  icon: 'fas fa-lock',
                  title: 'Security First',
                  description: 'Encryption, role-based access and strict compliance with healthcare data regulations.',
                },
                {
                  icon: 'fas fa-expand',
                  title: 'Scalable Architecture',
                  description: 'Start small, scale to enterprise-wide deployment without disruption.',
                },
                {
                  icon: 'fas fa-globe',
                  title: 'Localisation Ready',
                  description: 'Multi-language interface, local formats and region-specific compliance support.',
                },
              ].map((item, index) => (
                <div
                  key={index}
                  className={`bg-white rounded-2xl shadow-md p-4 sm:p-6 flex items-start gap-3 sm:gap-4 hover:shadow-xl hover:scale-105 transition-all duration-500 ${
                    visibleItems.includes(String(index + 31)) ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
                  }`}
                  data-index={index + 31}
                  ref={(el) => (itemRefs.current[index + 31] = el)}
                  data-aos="zoom-in"
                  data-aos-delay={index * 100}
                >
                  <i className={`${item.icon} text-indigo-600 text-xl sm:text-2xl`}></i>
                  <div>
                    <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-1 sm:mb-2">{item.title}</h3>
                    <p className="text-sm sm:text-base text-gray-700">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Section 6: Demo & Contact */}
        <section
          className="mb-12 sm:mb-16 lg:mb-20 bg-fixed bg-cover bg-center"
          style={{ backgroundImage: "url('/img/contact-bg.png')" }}
          data-aos="fade-up"
        >
          <div className="bg-white bg-opacity-90 rounded-2xl p-6 sm:p-8">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 text-center mb-6 sm:mb-8 lg:mb-10">
              Ready to Transform Your Healthcare Operations?
            </h2>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-16">
              <div className="bg-white rounded-2xl shadow-md p-6 sm:p-8" data-aos="fade-right">
                <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-4 sm:mb-6">Contact Info</h3>
                <div className="flex items-center mb-3 sm:mb-4">
                  <i className="bi bi-telephone text-indigo-600 text-xl sm:text-2xl mr-2 sm:mr-3"></i>
                  <p className="text-sm sm:text-base text-gray-700">+91 79932 56679, +91 7075742502</p>
                </div>
                <div className="flex items-center mb-4 sm:mb-6">
                  <i className="bi bi-envelope-open text-indigo-600 text-xl sm:text-2xl mr-2 sm:mr-3"></i>
                  <Link
                    to="mailto:info@SecurXpert.com"
                    className="text-sm sm:text-base text-gray-700 hover:text-blue-600 no-underline"
                  >
                    info@SecurXpert.com
                  </Link>
                </div>
                <div className="flex flex-col sm:flex-row gap-3 sm:gap-4" data-aos="fade-up" data-aos-delay="100">
                  <Link
                    to="/contact-us"
                    className="inline-block bg-indigo-600 text-white font-semibold py-2 px-6 sm:py-3 sm:px-8 rounded-lg hover:bg-indigo-700 transition duration-300 text-sm sm:text-base no-underline hover:scale-105"
                  >
                    Get a Free Quote
                  </Link>
                  <Link
                    to="/contact-us"
                    className="inline-block bg-orange-500 text-white font-semibold py-2 px-6 sm:py-3 sm:px-8 rounded-lg hover:bg-orange-600 transition duration-300 text-sm sm:text-base no-underline hover:scale-105"
                  >
                    Talk to Our Experts
                  </Link>
                </div>
              </div>
              <div className="bg-white rounded-2xl shadow-md p-6 sm:p-8" data-aos="fade-left">
                <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-4 sm:mb-6">Quick Form</h3>
                <form onSubmit={handleSubmit}>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-5">
                    <input
                      id="name"
                      type="text"
                      placeholder="Your Name"
                      value={formData.name}
                      onChange={handleInputChange}
                      className="w-full border border-gray-300 rounded-lg px-3 sm:px-4 py-2 sm:py-3 text-sm sm:text-base focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition"
                      required
                    />
                    <input
                      id="email"
                      type="email"
                      placeholder="Your Email"
                      value={formData.email}
                      onChange={handleInputChange}
                      className="w-full border border-gray-300 rounded-lg px-3 sm:px-4 py-2 sm:py-3 text-sm sm:text-base focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition"
                      required
                    />
                    <select
                      id="countryCode"
                      value={formData.countryCode}
                      onChange={handleInputChange}
                      className="w-full border border-gray-300 rounded-lg px-3 sm:px-4 py-2 sm:py-3 text-sm sm:text-base focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition"
                      required
                    >
                      <option value="+91">India (+91)</option>
                      <option value="+1">USA (+1)</option>
                      <option value="+1">Canada (+1)</option>
                      <option value="+44">UK (+44)</option>
                      <option value="+61">AUS (+61)</option>
                    </select>
                    <input
                      id="phone_number"
                      type="tel"
                      placeholder="Your Phone Number (+91)"
                      value={formData.phone_number}
                      onChange={handleInputChange}
                      pattern="[0-9]{10}"
                      className="w-full border border-gray-300 rounded-lg px-3 sm:px-4 py-2 sm:py-3 text-sm sm:text-base focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition"
                      required
                    />
                    <input
                      id="subject"
                      type="text"
                      placeholder="Subject"
                      value={formData.subject}
                      onChange={handleInputChange}
                      className="col-span-1 sm:col-span-2 w-full border border-gray-300 rounded-lg px-3 sm:px-4 py-2 sm:py-3 text-sm sm:text-base focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition"
                      required
                    />
                    <textarea
                      id="message"
                      placeholder="Message"
                      value={formData.message}
                      onChange={handleInputChange}
                      rows="4 sm:rows-5"
                      className="col-span-1 sm:col-span-2 w-full border border-gray-300 rounded-lg px-3 sm:px-4 py-2 sm:py-3 text-sm sm:text-base focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition"
                      required
                    ></textarea>
                  </div>
                  <button
                    type="submit"
                    className="mt-4 sm:mt-6 w-full bg-indigo-600 text-white font-semibold py-2 sm:py-3 rounded-lg hover:bg-indigo-700 transition duration-300 text-sm sm:text-base hover:scale-105"
                  >
                    Send Message
                  </button>
                  {formMessage && (
                    <div className="text-center mt-3 sm:mt-4 text-sm sm:text-base font-medium text-green-600 animate-fadeIn">
                      {formMessage}
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </section>

        {/* Section 7: FAQs */}
        <section className="mb-12 sm:mb-16 lg:mb-20" data-aos="fade-up">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 text-center mb-6 sm:mb-8 lg:mb-10">
            FAQs
          </h2>
          <div className="space-y-3 sm:space-y-4">
            {[
              {
                question: 'What software do hospitals use to manage operations?',
                answer:
                  'Hospitals use EHR software to store patient data and connect billing, pharmacy, lab, and other modules.',
              },
              {
                question: 'How much does hospital management software cost?',
                answer: 'The cost varies by facility size, modules, and cloud or on-premise options, with flexible pricing.',
              },
              {
                question: 'Can this HMS be used for different medical services?',
                answer:
                  'Yes, it can be customized for hospitals, clinics, labs, pharmacies, ambulances, and community health centers.',
              },
              {
                question: 'Can your HMS connect with other hospital systems?',
                answer:
                  'Yes, it integrates with EHR, PACS, LIS, RIS, payment gateways and health portals for seamless operation.',
              },
            ].map((faq, index) => (
              <div
                key={index}
                className={`bg-white rounded-2xl shadow-md p-4 sm:p-6 hover:shadow-xl transition-all duration-500 ${
                  visibleItems.includes(String(index + 36)) ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
                }`}
                data-index={index + 36}
                ref={(el) => (itemRefs.current[index + 36] = el)}
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                <strong className="text-base sm:text-lg font-semibold text-gray-900">{faq.question}</strong>
                <p className="text-sm sm:text-base text-gray-700 mt-2 animate-fadeIn">{faq.answer}</p>
              </div>
            ))}
          </div>
        </section>
      </div>

      {/* Footer */}
      <Footer />

      {/* Back to Top */}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className="fixed bottom-4 sm:bottom-6 right-4 sm:right-6 bg-orange-600 p-2 sm:p-3 md:p-4 rounded-full shadow-lg hover:bg-orange-700 transition hover:scale-110"
        aria-label="Back to top"
        data-aos="fade-in"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-5 h-5 sm:w-6 sm:h-6 text-black"
          fill="none"
          viewBox="0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
        </svg>
      </button>
      <style jsx>{`
        .animate-fadeIn {
          animation: fadeIn 1s ease-out;
        }
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default AdvancedHMS;